import EditorOutput from '@/components/common/EditorOutput';
import { Container } from '@/components/ui/Grid';
import MotionHeader from '@/components/ui/MotionHeader';
import Advantages from '@/components/About/Advantages';
import styles from "@/components/Invest/invest.module.scss";
import { motion } from 'framer-motion';
import clsx from "clsx";

const variants = {
    initial: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            duration: 1.3,
            delay: 1,
        },
    },
    hidden: { opacity: 0 },
};

const Invest = ({ data }) => {
    const {cooperation, criteria, priorities, honesty} = data
    return (
        <Container>
            {cooperation.title && <MotionHeader>{cooperation.title}</MotionHeader>}
            {cooperation.text &&
                <EditorOutput className={styles.cooperation} data={{
                    blocks: [{
                        type: "paragraph",
                        data: {
                            text: cooperation.text
                        }
                    }]
                }}/>
            }

            {priorities.title && <MotionHeader>{priorities.title}</MotionHeader>}
            <motion.div
                className={styles.prioritiesWrapper}
                initial="initial"
                animate="visible"
                exit="hidden"
                variants={variants}
            >
                <div className={styles.prioritiesItems}>
                    <div className={clsx(styles.row, styles.centerRow)}>
                        {priorities.blocks.slice(0, 2).map((p, index) => {
                            return (
                                <div key={index} className={clsx(styles.priority, styles.item)}>
                                    <div className={styles.header}>{p.title}</div>
                                    <div className={styles.text}>{ p.description }</div>
                                </div>
                            );
                        })}
                    </div>
                    <div className={styles.row}>
                        {priorities.blocks.slice(2, 5).map((p, index) => {
                            return (
                                <div key={index} className={clsx(styles.priority, styles.item)}>
                                    <div className={styles.header}>{p.title}</div>
                                    <div className={styles.text}>{ p.description }</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={clsx(styles.priority, styles.lastBlock)}>
                    <div className={styles.header}>{priorities.lastBlock.title}</div>

                    {priorities.lastBlock.description && (
                        <div className={styles.text} dangerouslySetInnerHTML={{__html: priorities.lastBlock.description}}/>
                    )}
                </div>
                <p className={styles.info} dangerouslySetInnerHTML={{__html: priorities.text}}/>
            </motion.div>

            {criteria.title && <MotionHeader>{criteria.title}</MotionHeader>}
            {criteria && <Advantages data={criteria} isInvest/>}

            <motion.div
                className={styles.honestyWrapper}
                initial="initial"
                animate="visible"
                exit="hidden"
                variants={variants}
            >
                <h2 className={styles.honestyTitle}>{honesty.title}</h2>
                <p className={styles.honestyText}>{honesty.text}</p>
            </motion.div>
        </Container>
    );
};

export default Invest;
